export default "__VITE_ASSET___IWXyvdC__"